export const isTextBasedFile = (file: File): boolean => {
  if (!file || !file.type) return false;

  const textTypes = [
    'text/plain',
    'text/csv',
    'text/html',
    'text/xml',
    'text/markdown',
    'application/json',
    'application/xml',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/msword',
    'application/rtf',
  ];

  const textExtensions = [
    '.txt', '.csv', '.docx', '.xlsx', '.xls', '.pptx', '.doc', '.rtf',
    '.json', '.xml', '.html', '.htm', '.md', '.markdown',
    '.log', '.sql', '.yaml', '.yml', '.toml', '.ini', '.cfg', '.conf',
  ];

  const hasTextType = textTypes.includes(file.type);
  const hasTextExtension = textExtensions.some(ext => file.name.toLowerCase().endsWith(ext));

  return hasTextType || hasTextExtension;
};

export const isPdfFile = (file: File): boolean => {
  if (!file) return false;
  return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
};

export const isMediaFile = (file: File): boolean => {
  if (!file || !file.type) return false;

  return (
    file.type.startsWith('image/') ||
    file.type.startsWith('video/') ||
    file.type.startsWith('audio/')
  );
};

export const categorizeFiles = (files: File[]): {
  media: File[];
  textBased: File[];
  pdfs: File[];
  unsupported: File[];
} => {
  const media: File[] = [];
  const textBased: File[] = [];
  const pdfs: File[] = [];
  const unsupported: File[] = [];

  files.forEach(file => {
    if (isPdfFile(file)) {
      pdfs.push(file);
    } else if (isMediaFile(file)) {
      media.push(file);
    } else if (isTextBasedFile(file)) {
      textBased.push(file);
    } else {
      unsupported.push(file);
    }
  });

  return { media, textBased, pdfs, unsupported };
};

